import React, { Component } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Input, Pagination } from "antd";
import styled from "styled-components";
import Navbar from "components/dashboard-nav";
import Sidebar from "components/dashboard-sidebar";
import * as Icon from "react-feather";
import { Link } from "react-router-dom";
import Loader from "../../components/widgets/loader";
import Moment from "react-moment";
import NoData from "../../components/no-data/NoData";
import TncForm from "components/widgets/forms/setup/TncForm";
import BasicDetails from "components/setup/BasicDetails";
import { fetch_product_details, file_url } from "services/apiSrv";
import PdfIcon from "assets/images/pdf.png";
import DocIcon from "assets/images/doc-icon.png";
import FileIcon from "assets/images/file-icon.png";
import ExcelIcon from "assets/images/Excel-Icon.png";
import { fileExtension } from "utils/helpers";

// Styled components
const Document = styled.div`
  margin-bottom: 40px;
  display: grid;
  grid-gap: 50px;
`;

const DocumentRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
`;

const DocumentTitle = styled.a`
  line-height: 1.5em;
  font-size: 15px;
  margin-top: 1rem;
`;

const DocumentLogo = styled.img`
  max-width: 70px;
`;

const DocumentItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

const DocumentLogoContainer = styled.div`
  display: block;
  &:hover {
    background-color: black;
    width: 100px;
    height: 100px;
    margin: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.3s ease-in-out;
  }
`;

const DeleteDocument = styled.div``;

const checkExtension = (file_path) => {
  if (!file_path) return FileIcon;
  let ext = fileExtension(file_path)?.toLowerCase();
  switch (ext) {
    case "pdf":
      return PdfIcon;
    case "xls":
    case "xlsx":
      return ExcelIcon;
    case "doc":
    case "docx":
      return DocIcon;
    default:
      return FileIcon;
  }
};

// Error Boundary Component
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong. Please try again.</div>;
    }
    return this.props.children;
  }
}

export default function Claims({
  state,
  view_claim_details,
  search,
  paginate,
  setPaginate,
  numEachPage,
  handlePaginationChange,
}) {
  const { Search } = Input;
  const history = useHistory();
  const { id: productSystemRef } = useParams();

  console.log("productSystemRef:", productSystemRef);

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["productDetails", productSystemRef],
    queryFn: () => fetch_product_details(productSystemRef),
    enabled: !!productSystemRef,
    retry: 2,
    staleTime: 5 * 60 * 1000,
    onError: (err) => console.error("Query error:", err),
  });

  console.log("Fetched data:", data);

  const productTnc = data?.data?.length > 0 ? data.data[0].productTnc : null;

  if (!productSystemRef) {
    history.push("/dashboard");
    return null;
  }

  return (
    <ErrorBoundary>
      <div className="pageheader pd-t-25 pd-b-35">
        <div className="breadcrumb pd-0 mg-0">
          <a className="breadcrumb-item" href="index.html">
            <i className="icon ion-ios-home-outline" /> Home
          </a>
          <a className="breadcrumb-item active" href>
            Dashboard
          </a>
        </div>
      </div>
      <div className="col-lg-12 card rounded-10 col-xl-12">
        {isLoading && <Loader />}
        {isError && <div>Error: {error.message}</div>}
        {!isLoading && !isError && !data?.data?.length && (
          <div>No product details available for this ID.</div>
        )}
        {data?.data?.length > 0 && (
          <>
            <BasicDetails />
            <h4>Appointment terms and conditions page</h4>
            <TncForm />
            {productTnc && productTnc.documentType && productTnc.uploadPath ? (
              <Document>
                <DocumentRow>
                  <DocumentItem>
                    <span>{productTnc.documentType}</span>
                    <DocumentLogo
                      src={checkExtension(productTnc.uploadPath)}
                      alt="document"
                    />
                    <DocumentLogoContainer>
                      <DeleteDocument>Delete</DeleteDocument>
                    </DocumentLogoContainer>
                    <DocumentTitle
                      href={`${productTnc.uploadPath}`}
                      target="_blank"
                    >
                      Preview
                    </DocumentTitle>
                  </DocumentItem>
                </DocumentRow>
              </Document>
            ) : (
              <div>No terms and conditions data available.</div>
            )}
          </>
        )}
      </div>
    </ErrorBoundary>
  );
}